// A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review.
/** Returns the pixel height of the lbj-header web component.
 * @returns {number}
 */
export function getPageHeader() {
  let headerComponent = document.querySelector("lbj-header");
  let pageHeader =
    headerComponent?.shadowRoot?.querySelector(".header__condensed") ||
    document.querySelector(".header__condensed");
  return pageHeader?.clientHeight || 0;
}

/** Returns the pixel height of the Drupal admin toolbar.
 * @returns {number}
 */
export function getDrupalHeader() {
  let drupalHeader = document.querySelector("#toolbar-administration");
  return drupalHeader?.clientHeight || 0;
}

/** Returns the combined height of the page header and Drupal toolbar.
 * @returns {number}
 */
export function getTotalHeaderHeight() {
  return getPageHeader() + getDrupalHeader();
}
